import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con1',
  templateUrl: './e-con1.component.html',
  styleUrls: ['./e-con1.component.css']
})
export class ECon1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
